import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=6ab47adf&scoped=true&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=6ab47adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab47adf",
  null
  
)

export default component.exports